module.exports = {
    achromaticSchemeColor: {},
    monochromaticSchemeColor: {},
    complementarySchemeColor: {},
    analogousSchemeColor: {},
    triadicSchemeColor: {},
    tetradicSchemeColor: {}
};
